import { Immutable } from "immer";
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as NPSSurvey } from "./NPSSurveyTemplate";

export const Template = (
    props: Immutable<templates.NPSSurveyDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl">
                <NPSSurvey
                    order_id={props.order_id}
                    survey_question={props.survey_question}
                />
            </div>
            <DataLayerPush events={props.ga_events} />
        </PageSkeleton>
    );
};
